import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import AOS from "aos";
import "./assets/global.css";
import "aos/dist/aos.css";
import { resolveSchema, resolveSeo } from "@/utils/seo";
import { registerServiceWorker } from "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();

function setMetaDescription(description) {
  let metaDescription = document.querySelector('meta[name="description"]');

  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.setAttribute("name", "description");
    document.head.appendChild(metaDescription);
  }

  metaDescription.setAttribute("content", description);
}

function setStructuredData(schema) {
  let script = document.getElementById("ohyes-route-schema");

  if (!script) {
    script = document.createElement("script");
    script.id = "ohyes-route-schema";
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(schema);
}

router.beforeEach((to, from, next) => {
  const seo = resolveSeo(to);
  document.title = seo.title;
  setMetaDescription(seo.description);
  setStructuredData(resolveSchema(to));
  next();
});

AOS.init({
  duration: 1000,
  easing: "ease-in-out",
  once: false,
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

registerServiceWorker();
